import { PASSPORT_SUBMENU_PRIVILLAGE_REQUEST, PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS, SUBMENU_PRIVILLAGE_REQUEST, SUBMENU_PRIVILLAGE_SUCCESS } from "../constants/subMenuPrivillageConstants";

export const checkSubmenuPrivillageReducer = (state = {}, action) => {
    switch(action.type) {
        case SUBMENU_PRIVILLAGE_REQUEST:
            return {
                ...state,
                checkPrivillageLoading: true,
            }

        case SUBMENU_PRIVILLAGE_SUCCESS:
            return {
                ...state,
                checkPrivillageLoading: false,
                submenuPrivillageSuccess: action.payload
            }
            default:
                return state;
    }
}

export const checkPassportSubMenuPrivillageReducer = (state = {}, action) => {
    switch(action.type) {
        case PASSPORT_SUBMENU_PRIVILLAGE_REQUEST:
            return {
                ...state,
                checkPassportPrivillageLoading: true
            }
        case PASSPORT_SUBMENU_PRIVILLAGE_SUCCESS:
            return {
                ...state,
                checkPassportPrivillageLoading: false,
                passportSubmenuSuccess: action.payload
            }
            default:
                return state
    }
}